import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox, VBox } from '../../../components/Box';
import { Modal, ModalControls } from '../../../components/Modal';
import { Button } from '../../../components/Buttons';
import { Checkbox } from '../../../components/Checkbox';
import { FormField } from '../../../components/FormFields';
import { DecoratorLabel, Input } from '../../../components/Input';
import { initiateNewOrderValue, setNewOrderValue, addVehicleToOutgoingOrder } from '../../Vehicles/actions';
import { selectUserId, selectWork, selectWorks } from '../../Api/selectors';
import { selectNewOrder } from '../../Vehicles/selectors';
import { BORDER_GREY_LIGHT } from '../../../vars';
import { INVOICE_DIRECTIONS, OutgoingCostTypes, REQUEST_CREATE_INVOICE } from '../constants';
import { fetchAllProducts, fetchCompanyProductsIds, fetchProducts } from '../../products/actions';
import { selectProducts } from '../../products/selectors';
import { REQUEST_COMPANY_PRODUCTS_IDS, PRODUCT_STATUS, REQUEST_PRODUCTS } from '../../products/constants';
import { Loader } from '../../../components/Loader';
import { fixPriceFormat, formatCurrency, getQuantOfDecimalPlaces } from '../../../utils/string';
import { stringToNumber } from '../../Shared/helpers/general';
import { OneTimeProduct } from './AddOneTimeProduct/OneTimeProduct';
import { AddOneTimeProductModal } from './AddOneTimeProduct/AddOneTimeProductModal';
import styles from './ProductsAndCostsModal.module.css';
import cn from 'classnames';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';

import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import { SearchSelect } from '../../../components/SearchSelect';
import { fetchCompany } from '../../Companies/actions';
import { fetchUser } from '../../Users/actions';
import { EditableSearchSelect } from '../../../components/EditableSearchSelect';
import { ProductDefaultTasksModalConfirmation } from '../../products/components/productDefaultTasksModal';
import { formatToTwoDecimalPlaces, limitToTwoDecimalPlaces } from '../../../utils/number';

const STATE = {
  saveDisable: false,
  inclMainProd: true,
  isTransportProduct: false,
  reqFieldMessage: null,
  closeModal: false,
  costDto: null,
  secondaryProducts: {
    product_1: {
      id: 'product_1',
      costType: '',
      cost: '',
      cost_incl_vat_per_item: '',
      cost_excl_vat_per_item: '',
      one_time: '',
      incl: true,
    },
  },
  secondaryManualProducts: [],
};

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  .modal-content-block {
    margin-bottom: 80px;
  }

  .label {
    display: flex;
  }

  .small-input {
    min-width: 115px;
  }

  .address-block {
    border: 1px solid ${BORDER_GREY_LIGHT};
    padding: 5px;
  }

  .selection-block {
    margin-bottom: 12px;
  }

  .req-field-message {
    color: red;
  }

  .medium-dropdown {
    width: 350px;
    @media (min-width: 800px) and (max-width: 1200px) {
      width: 220px;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class ProductAndCostsModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      selectedCompany: props?.vehicle?.buyingCompany ?? null,
    });
  }

  componentDidMount() {
    this.props.fetchCompanyProductsIds(res => {
      if (res?.length) {
        const taxRegion = this.props.company?.properties?.find(p => p?.name?.name === 'company_from_eu')?.value;
        const options = {};
        if (this.props.company?.id) options.companyId = this.props.company?.id;
        if (taxRegion) options.taxRegion = taxRegion;
        if (this.props.vehicle?.vehicle_purpose) options.vehiclePurpose = this.props.vehicle?.vehicle_purpose;
        this.props.fetchProducts(options);
      } else {
        this.props.fetchProducts();
      }
    });

    if (this.props.copiedSubjects?.length) {
      const productSubjects = this.props.copiedSubjects?.filter(subject => {
        return subject?.product?.id;
      });
      const manualProducts = this.props.copiedSubjects?.filter(subject => {
        return !subject?.product?.id;
      });
      this.setState({
        secondaryProducts: productSubjects?.map(productSubject => {
          let product = {
            product_id: productSubject?.product.id,
            cost: productSubject?.product_price_excl_vat,
            incl: true,
            one_time: productSubject?.one_time,
            counter: productSubject?.product?.isCounter,
            costType: productSubject?.product?.name,
            isTransport: productSubject?.product.isTransport,
            description: productSubject?.product.description,
            cost_excl_vat_per_item: productSubject?.product_price_excl_vat_per_item,
          };
          if (this.props.editInvoice && productSubject?.id) {
            product.subjectId = productSubject?.id;
            product.currentSubject = productSubject;
          }

          return product;
        }),
        secondaryManualProducts: manualProducts?.map(manualProduct => {
          let product = {
            description: manualProduct.description,
            price: manualProduct.product_price_excl_vat,
            vat_code: manualProduct.subjectVat?.code,
            ledger: manualProduct.ledger,
            price_excl_vat: manualProduct.product_price_excl_vat_per_item,
            price_excl_vat_per_item: manualProduct.product_price_excl_vat_per_item,
            price_incl_vat: manualProduct.product_price_incl_vat_per_item,
            one_time: manualProduct.one_time,
          };
          if (this.props.editInvoice && manualProduct?.id) {
            product.subjectId = manualProduct?.id;
            product.id = manualProduct?.id;
            product.currentSubject = manualProduct;
          }

          return product;
        }),
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.costDto !== this.state.costDto) {
      this.updateProductState(this.state.costDto?.value, this.state.costDto?.key, 'cost', this.state.costDto?.prod);
    }
  }

  get productPrice() {
    const price = this.props.direction == INVOICE_DIRECTIONS.INCOMING ? 'purchasePriceExclVat' : 'salesPriceExclVat';

    return price;
  }

  get productInclPrice() {
    const price = this.props.direction == INVOICE_DIRECTIONS.INCOMING ? 'purchasePrice' : 'salesPrice';

    return price;
  }

  get productInclPrice() {
    const price = this.props.direction == INVOICE_DIRECTIONS.INCOMING ? 'purchasePrice' : 'salesPrice';

    return price;
  }

  get options() {
    let options = [];
    for (let product of this.availableProducts) {
      const label = `${product?.name ?? ''} - ${formatCurrency(product[this.productPrice] || '0')}`;
      options.push({ label, value: product.name, id: product?.id, isCounter: product?.isCounter });
    }

    return options;
  }

  get saveButtonLabel() {
    const label = this.props.workCreate ? <Loader small /> : this.lbl(`confirm`);
    return this.state.saveDisable ? this.lbl('calculating_progreess') : label;
  }

  getValue(name) {
    const value = this.options.find(o => o.value == name);
    return { id: value?.id, isCounter: value?.isCounter };
  }

  get secondaryTotalPrice() {
    let totalPrice = 0;
    Object.values(this.state.secondaryProducts).map(value => (totalPrice += stringToNumber(value.cost)));
    const totalManualProductsPrice = this.state.secondaryManualProducts.reduce((prev, cur) => {
      if (cur.price) {
        return prev + stringToNumber(cur.price);
      }
      return prev;
    }, 0);
    return totalPrice + totalManualProductsPrice;
  }

  onChangeQuantity(value, key, prop, selectedProduct) {
    const enteredValue = value || '';
    if (getQuantOfDecimalPlaces(enteredValue) > 2) return;
    this.setState(prev => ({
      saveDisable: true,
      secondaryProducts: {
        ...prev.secondaryProducts,
        [key]: {
          ...prev.secondaryProducts[key],
          one_time: value,
        },
      },
    }));
    if (enteredValue) {
      this._t = this.timeout(() => this.onSetFixedValue(enteredValue, key, prop, selectedProduct), 2500, this._t);
    }
    // this._t = this.timeout(() => this.handleSetProducts(value, key, prop, selectedProduct), 2500, this._t);
  }

  onChangeProductPrice(evt, value, key) {
    if (getQuantOfDecimalPlaces(evt.target.value) > 2) return;
    this.setState({ saveDisable: true });
    const enteredValue = evt.target.value;
    this.setState({
      costDto: {
        key: key,
        value: enteredValue,
        prod: {
          id: value?.product_id,
          counter: value?.counter,
        },
      },
    });
  }

  onSetFixedValue(value, key, prop, selectedProduct) {
    const roundValue = value ? parseFloat(value?.replace(',', '.')) : value;
    this.setState(prev => ({
      saveDisable: true,
      secondaryProducts: {
        ...prev.secondaryProducts,
        [key]: {
          ...prev.secondaryProducts[key],
          [prop]: fixPriceFormat(roundValue),
        },
      },
    }));

    this.handleSetProducts(fixPriceFormat(roundValue), key, prop, selectedProduct);

    this.setState({
      saveDisable: false,
    });
  }

  onChangeProductPricePerItem(value, key, prop, selectedProduct) {
    const enteredValue = value || '';
    if (getQuantOfDecimalPlaces(enteredValue) > 2) return;
    this.setState(prev => ({
      saveDisable: true,
      secondaryProducts: {
        ...prev.secondaryProducts,
        [key]: {
          ...prev.secondaryProducts[key],
          cost_excl_vat_per_item: value,
        },
      },
    }));
    if (enteredValue) {
      this._t = this.timeout(() => this.onSetFixedValue(enteredValue, key, prop, selectedProduct), 2500, this._t);
    }
  }

  updateProductState(value, key, prop, selectedProduct) {
    const product = this.availableProducts.find(i => i.id === selectedProduct?.id);
    let productPrice =
      this.state.costDto?.value && this.state.costDto?.key == key ? this.state.costDto?.value : product[this.productPrice];
    this.setState(prev => ({
      secondaryProducts: {
        ...prev.secondaryProducts,
        [key]: {
          ...prev.secondaryProducts[key],
          cost: productPrice ?? 0,
          counter: product.isCounter,
        },
      },
    }));

    this._t = this.timeout(() => this.handleSetProducts(value, key, prop, selectedProduct), 2500, this._t);
  }

  needToShowDefaultTasksConfirmation(product) {
    const productObj = this.availableProducts.find(p => p.id === product.id);
    return (
      this.props.direction === INVOICE_DIRECTIONS.OUTGOING && !!this.props.vehicle?.id && !!productObj?.productTasks?.length
    );
  }

  onConfirmTasksModalConfirmation(product) {
    this.setState({ applyDefaultTasks: true, showDefaultTasksModal: false });
  }

  onCancelTasksModalConfirmation(product) {
    this.setState({ applyDefaultTasks: false, showDefaultTasksModal: false });
  }

  handleSetProducts = (value, key, prop, selectedProduct) => {
    let product = this.state.secondaryProducts[key];

    if (prop === 'editName') {
      this.setState(prevState => ({
        saveDisable: false,
        secondaryProducts: {
          ...prevState.secondaryProducts,
          [key]: { ...product, editedName: value },
        },
        showDefaultTasksModal: this.needToShowDefaultTasksConfirmation(selectedProduct),
      }));
      return;
    }

    const productInfo = this.availableProducts.find(i => i.id === selectedProduct?.id);

    const defaultProductPrice = parseFloat(productInfo[this.productPrice]?.toString().replace(',', '.')) || 0;
    const defaultProductInclVatPrice = parseFloat(productInfo[this.productInclPrice]?.toString().replace(',', '.')) || 0;

    const vatRate =
      defaultProductInclVatPrice > 0 ? ((defaultProductInclVatPrice - defaultProductPrice) / defaultProductPrice) * 100 : 0;

    let productPrice = product?.cost_excl_vat_per_item || defaultProductPrice;
    productPrice =
      typeof productPrice === 'number' ? productPrice : parseFloat(productPrice.toString().replace(',', '.')) || 0;

    let quantity = 1;
    if (
      // prop !== 'costType' &&
      this.props.vehicle?.id &&
      this.props.vehicle[productInfo?.counter] &&
      productInfo?.isCounter
    ) {
      quantity = this.props.vehicle[productInfo?.counter];
    }

    quantity = stringToNumber(quantity);

    if (prop === 'cost_excl_vat_per_item') {
      productPrice = +value;
      const vatPerItem = productPrice * (vatRate / 100);
      const pricePerItemInclVat = productPrice + vatPerItem;
      product = {
        ...product,
        cost_incl_vat_per_item: pricePerItemInclVat.toFixed(15),
        counter: productInfo?.isCounter,
      };
    } else if (prop === 'one_time') {
      quantity = +value;
    } else if (prop === 'costType') {
      productPrice = defaultProductPrice;
      const pricePerItemInclVat = defaultProductInclVatPrice;
      product = {
        ...product,
        costType: value,
        cost_excl_vat_per_item: defaultProductPrice.toFixed(15),
        cost_incl_vat_per_item: pricePerItemInclVat.toFixed(15),
        one_time: 1,
        counter: productInfo?.isCounter,
        editedName: selectedProduct?.editedName,
      };
    }

    let price = quantity ? quantity * productPrice : productPrice;
    price = !isNaN(price) && price !== 0 ? price.toFixed(15) : '0.00';

    const updatedProduct = {
      ...product,
      product_id: productInfo.id,
      cost: price,
      one_time: quantity,
      counter: productInfo?.isCounter,
    };

    this.setState(prevState => ({
      saveDisable: false,
      secondaryProducts: {
        ...prevState.secondaryProducts,
        [key]: updatedProduct,
      },
      showDefaultTasksModal: this.needToShowDefaultTasksConfirmation(selectedProduct),
    }));
  };

  isProductOption(key) {
    return !Object.keys(OutgoingCostTypes).includes(key);
  }

  addProduct() {
    const length = Object.keys(this.state.secondaryProducts).length;

    this.setState(prev => ({
      secondaryProducts: {
        ...prev.secondaryProducts,
        [`product_${length + 1}`]: {
          id: `product_${length + 1}`,
          costType: '',
          cost: '',
          incl: true,
        },
      },
    }));
  }

  addOneTimeProduct(value = null) {
    const newState = {
      showAddManualProductModal: true,
    };

    if (value) {
      newState.editMode = true;
      newState.currentManualProduct = value;
    }
    this.setState(newState);
  }

  closeOneTimeProductModal(turnOffEditMode = false) {
    const newState = {
      showAddManualProductModal: false,
    };

    if (turnOffEditMode) {
      newState.editMode = false;
    }
    this.setState(newState);
  }

  save() {
    let costs = [];
    const products = [];
    const oneTimeProducts = [];

    Object.entries(this.state.secondaryProducts).forEach(([key, val]) => {
      if (!val.incl && !val.currentSubject?.id) {
        return;
      }
      let dtoObj = null;
      const isProduct = this.isProductOption(val.costType);
      if (this.isProductOption(val.costType)) {
        dtoObj = this.mapProductToDtoObj(val);
      } else {
        dtoObj = this.mapCostToDtoObj(val);
      }
      if (isProduct && dtoObj) products.push(dtoObj);
      if (!isProduct && dtoObj) costs.push(dtoObj);
    });

    this.state.secondaryManualProducts.forEach(product => {
      if (product.incl || product.currentSubject?.id) {
        oneTimeProducts.push(this.mapOneTimeProductToSubject(product, this.props.vehicle?.id));
      }
    });

    const properties = {
      costs,
      products,
      oneTimeProducts,
      applyDefaultTasks: this.state.applyDefaultTasks,
    };

    this.props.onConfirm(properties);
  }

  mapCostToDtoObj(val) {
    const isInclBtwBpm = this.props.values.tax_type == 'incl.BTW/BPM';
    let priceKey = isInclBtwBpm ? 'cost_price_incl_vat' : 'cost_price_excl_vat';
    let costObj = {
      costType: val.costType,
      [priceKey]: val.cost,
    };

    if (!costObj.costType || !costObj[priceKey]) return null;
    return costObj;
  }

  mapOneTimeProductToSubject(val, vehicleId) {
    // When enable these 2 lines below - in result invoice have 0 price for manual products
    // const exclVat = this.props.editInvoice ? 'product_price_excl_vat_per_item' : 'product_price_excl_vat';
    // const inclVat = this.props.editInvoice ? 'product_price_incl_vat_per_item' : 'product_price_incl_vat';
    const exclVat = 'product_price_excl_vat_per_item';
    const inclVat = 'product_price_incl_vat_per_item';
    const one_time = +val.one_time ?? 1;
    const vatBaseAmount = +val.price_excl_vat * one_time;
    const vatAmount = (+val.price_incl_vat - +val.price_excl_vat) * one_time;
    let productSubject = {
      description: val.description ?? '',
      vehicleId,
      economicalPrice: +val.price ?? 0,
      type: 'product',
      subjectVat: { code: val.vat_code, baseAmount: vatBaseAmount, amount: vatAmount },
      ledger: val.ledger,
      [exclVat]: +val.price_excl_vat ?? 0,
      // product_price_excl_vat_per_item: +val.cost ?? 0,
      [inclVat]: +val.price_incl_vat ?? 0,
      one_time: +val.one_time ?? 1,
      manuallyCreated: true,
    };

    if (val?.currentSubject?.id) {
      productSubject.id = val?.subjectId;
      productSubject.currentSubject = val.currentSubject;
    }
    return productSubject;
  }

  mapProductToDtoObj(val) {
    const isInclBtwBpm = this.props.values.tax_type === 'incl.BTW/BPM';
    const priceKey = isInclBtwBpm ? 'product_price_incl_vat' : 'product_price_excl_vat';
    const priceInclVatPerItemKey = 'product_price_incl_vat_per_item';
    const priceExclVatPerItemKey = 'product_price_excl_vat_per_item';

    let oneTime = val.counter === '1' ? 1 : stringToNumber(val.one_time);
    let costPerItem = val.counter === '1' || val.currentSubject?.id ? +val.cost : +val.cost / oneTime;
    const one_time_key = val.counter ? 'one_time_manual' : 'one_time';
    let productObj = {
      product_id: val.product_id,
      [priceKey]: costPerItem.toFixed(15),
      [priceInclVatPerItemKey]: +val.cost_incl_vat_per_item,
      [priceExclVatPerItemKey]: +val.cost_excl_vat_per_item,
      [one_time_key]: oneTime,
    };
    if (val.editedName) productObj.description = val.editedName;
    if (val?.subjectId) {
      productObj.id = val.subjectId;
      productObj.currentSubject = val.currentSubject;
    }

    return productObj;
  }

  reset() {
    this.setState({ ...STATE });
  }

  onIsIncludeMainProduct() {
    if (this.state.inclMainProd) {
      this.props.setValue('', 'main_cost');
    }
    this.setState({ inclMainProd: !this.state.inclMainProd });
  }

  onIsIncludeSecondaryProduct(value, key) {
    if (this.state.secondaryProducts[key]?.costType === 'TRANSPORT') {
      this.resetTransportProduct();
    }

    this.setState(prev => {
      const updatedProduct = prev.secondaryProducts[key]?.incl
        ? {
            ...prev.secondaryProducts[key],
            costType: '',
            cost: '',
            incl: false,
            cost_excl_vat_per_item: '',
            cost_incl_vat_per_item: '',
            one_time: '',
          }
        : {
            ...prev.secondaryProducts[key],
            incl: !prev.secondaryProducts[key].incl,
          };

      return {
        secondaryProducts: {
          ...prev.secondaryProducts,
          [key]: updatedProduct,
        },
      };
    });
  }

  onIsIncludeSecondaryManualProduct(evt, key) {
    this.state.secondaryManualProducts.map((prod, index) => {
      if (prod.id == key) {
        const newSecondaryManualProducts = this.state.secondaryManualProducts;
        newSecondaryManualProducts[index].incl = !newSecondaryManualProducts[index].incl;
        this.setState({ secondaryManualProducts: [...newSecondaryManualProducts] });
      }
    });
  }

  get availableProducts() {
    // TODO filter based on direction, purpose

    return this.props.availableProducts?.filter(
      p => p.status != PRODUCT_STATUS.DEACTIVE && p.status != PRODUCT_STATUS.DELETED,
    );
  }

  onAddOneTimeProduct(oneTimeProduct) {
    this.setState({ secondaryManualProducts: [...this.state.secondaryManualProducts, oneTimeProduct] });
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Container>
        {this.state.showDefaultTasksModal && (
          <ProductDefaultTasksModalConfirmation
            onConfirm={this.onConfirmTasksModalConfirmation.bind(this)}
            onCancel={this.onCancelTasksModalConfirmation.bind(this)}
          />
        )}
        <ModalComponent
          halfParentWide
          size="xl"
          onClose={this.props.reset}
          title={this.lblStr('vehicle.order.add_outgoing_order')}
        >
          {/* <div className={cn('progress mb-2', styles.progress)}>
            <div
              className={cn('progress-bar', styles.progressBar)}
              role="progressbar"
              style={{ width: `${this.props.step * 50}%` }}
              aria-valuenow={this.props.step}
              aria-valuemin="1"
              aria-valuemax="2"
            >
              {this.props.step} of 2
            </div>
          </div> */}
          <VBox left className="modal-content-block">
            {Object.entries(this.state.secondaryProducts).map(([key, value]) => (
              <div className={styles.containerSecondaryProducts}>
                <div className={cn(styles.productContainer, styles.container)} key={value.id}>
                  <div className={styles.hBox}>
                    <CheckboxComponent checked={value.incl} onChange={evt => this.onIsIncludeSecondaryProduct(evt, key)} />
                    <EditableSearchSelect
                      className="medium-dropdown"
                      options={value.incl ? this.options : []}
                      placeholder={'Select...'}
                      value={value.costType && { label: value.costType }}
                      onChange={evt => this.handleSetProducts(evt.value, key, 'costType', this.getValue(evt?.value))}
                      onEdit={evt => this.handleSetProducts(evt.value, key, 'editName', this.getValue(evt?.value))}
                    />
                  </div>
                  <div className={cn(styles.hBox, styles.priceContainer)}>
                    <div className={styles.inputPrice}>
                      <label className="form-label">{this.lbl('product.invoice-modal.product.piece_excl_vat')}</label>
                      <input
                        className={'form-control'}
                        disabled={!value.incl || !value?.product_id}
                        name={value.id}
                        type="text"
                        value={limitToTwoDecimalPlaces(value.cost_excl_vat_per_item)}
                        rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
                        onChange={evt =>
                          this.onChangeProductPricePerItem(evt.target.value, key, 'cost_excl_vat_per_item', {
                            id: value?.product_id,
                            counter: value?.counter,
                          })
                        }
                      />
                    </div>

                    <div className={styles.inputPrice}>
                      <label className="form-label">{this.lbl('product.quantity')}</label>
                      <input
                        className="form-control"
                        disabled={!value.incl || !value?.product_id || value?.counter == '1'}
                        name={value.id}
                        type="text"
                        value={value.one_time}
                        rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
                        onChange={evt =>
                          this.onChangeQuantity(evt.target.value, key, 'one_time', {
                            id: value?.product_id,
                            counter: value?.counter,
                          })
                        }
                      />
                    </div>
                    <div className={styles.inputPrice}>
                      <label className="form-label">{this.lbl('product.invoice-modal.total_price_excl_vat')}</label>
                      <input
                        className="form-control"
                        disabled={!value.incl || !value?.product_id}
                        name={value.id}
                        type="text"
                        placeholder="price"
                        value={formatToTwoDecimalPlaces(value.cost)}
                        rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
                        // onChange={evt => {
                        //   this.onChangeProductPrice(evt, value, key);
                        // }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {this.state.secondaryManualProducts.length ? (
              <label className="form-label">{this.lblStr('vehicle.order.manually_created_products')}</label>
            ) : (
              ''
            )}
            {this.state.secondaryManualProducts.map(value => (
              <OneTimeProduct
                value={value}
                onIsIncludeSecondaryManualProduct={(evt, id) => this.onIsIncludeSecondaryManualProduct(evt, id)}
                onClick={() => {
                  this.addOneTimeProduct(value);
                }}
              />
            ))}
            <HBox style={{ width: '50' }} vCenter left>
              <Button small onClick={() => this.addProduct()}>
                {this.lbl('product.addproduct')}
              </Button>
              <Button small onClick={() => this.addOneTimeProduct()}>
                {this.lbl('product.addproductmanual')}
              </Button>
            </HBox>
            <HBox style={{ width: '25%' }}>
              {this.state.showAddManualProductModal && (
                <AddOneTimeProductModal
                  currentManualProduct={this.state.editMode && this.state.currentManualProduct}
                  secondaryManualProducts={this.state.secondaryManualProducts}
                  onComplete={currentOneTimeProduct => {
                    let secondaryManualProducts = this.state.secondaryManualProducts;
                    let turnOffEditMode = false;
                    if (this.state.editMode) {
                      const oldProductIndex = secondaryManualProducts.findIndex(
                        product => product.id === currentOneTimeProduct.id,
                      );
                      secondaryManualProducts[oldProductIndex] = currentOneTimeProduct;
                      turnOffEditMode = true;
                    } else {
                      secondaryManualProducts = [...secondaryManualProducts, { ...currentOneTimeProduct }];
                    }
                    this.setState({ secondaryManualProducts: [...secondaryManualProducts] }, () =>
                      this.closeOneTimeProductModal(turnOffEditMode),
                    );
                  }}
                  onClose={() => {
                    let turnOffEditMode = false;
                    if (this.state.editMode) turnOffEditMode = true;
                    this.closeOneTimeProductModal(turnOffEditMode);
                  }}
                />
              )}
            </HBox>
            {/* <HBox vCenter>
              <strong>{this.lbl('vehicle.order.total_price')}: </strong>
              <HBox style={{ maxWidth: '200px' }} vCenter>
                <label className="w-100">{this.lbl('product.invoice-modal.total_price_excl_vat')}</label>
                <div className="d-flex align-items-center gap-2 w-100">
                  <input
                    disabled
                    className="form-control"
                    value={this.secondaryTotalPrice.toFixed(2) || ''}
                    rightDecoration={<DecoratorLabel>€</DecoratorLabel>}
                  />
                </div>
              </HBox>
            </HBox> */}
          </VBox>

          <div className={cn('d-flex gap-2 mt-2', styles.buttonContainer)}>
            <Button disabled={this.props.workCreate} onClick={this.props.reset}>
              {this.lbl(`cancel`)}
            </Button>
            <Button
              primary
              disabled={this.props.workCreate || this.state.saveDisable}
              type="submit"
              onClick={() => this.save()}
            >
              {this.saveButtonLabel}
            </Button>
          </div>
        </ModalComponent>
      </Container>
    );
  }
}

ProductAndCostsModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  address: PropTypes.object,
  vehicle: PropTypes.object,
  reset: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedInUserId: selectUserId(),
    values: selectNewOrder(),
    availableProducts: selectProducts(),
    workCreate: selectWork(REQUEST_CREATE_INVOICE),
    work: selectWorks([REQUEST_PRODUCTS, REQUEST_COMPANY_PRODUCTS_IDS]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchUser(id, callback) {
      dispatch(fetchUser(id, callback));
    },
    fetchCompany(id, callback) {
      dispatch(fetchCompany(id, callback));
    },
    initiateValue(type) {
      dispatch(initiateNewOrderValue(type));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewOrderValue(name, value));
    },
    addToOrder(id, properties, callback) {
      dispatch(addVehicleToOutgoingOrder(id, properties, callback));
    },
    fetchProducts: (options = {}) => {
      dispatch(fetchAllProducts(options));
    },
    fetchCompanyProductsIds(callback) {
      dispatch(fetchCompanyProductsIds(ownProps.company?.id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductAndCostsModal = compose(withConnect, withRouter, injectIntl)(ProductAndCostsModalComp);
